export const Folder = {
  COLORS: [
    '#000000',
    '#7B0000',
    '#EF0B25',
    '#F2C049',
    '#F2A449',
    '#76BF76',
    '#FF405D',
    '#9440FF',
    '#3199F0',
    '#0D45A4',
  ],
};

export const DashFoldersRoute = {
  DASHFOLDERS: 'dashfolders',
};

export const DashFolderPathName = {
  DASHFOLDERS: 'dashfolders',
};

export const FolderAccessType = {
  CLIENT: 'client',
  CLIENT_GROUP: 'client_group',
  CLUSTER: 'cluster',
};

export const DashFolderClasses = {
  MULTISELECT_TAGS: 'multiselect__tags',
  MULTISELECT_INPUT: 'multiselect__input',
  MODAL_CARD_BODY: 'modal-card-body',
};

export const FolderEvent = {
  ON_CREATE_FOLDER_CLICK: 'on-create-folder-click',
  REFRESH_FOLDERS: 'dash_refresh_folders',
  ON_DASHBOARD_ASSIGNMENT: 'dashboard-assignment',
};

export const Constant = {
  DASHBOARD_MOVED_TO_FOLDER: 'Dashboard moved to folder',
  DASHBOARD_MOVED_OUT_FOLDER: 'Dashboard moved out of folder',
  SUCCESSFULLY: 'successfully',
  ADD_TO_FOLDER: 'Add To Folder',
  MOVE_TO_FOLDER: 'Move To Folder',
  NAME: 'name',
  DELETE: 'Delete',
  UPDATED_AT: 'updated_at',
  REQUIRED: 'required',
  FOLDERS: 'folders',
  TITLE: 'title',
  DELETE_MESSAGE: 'Cannot delete the folder because it contains files.',
};
